import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  flag: {
    width: '26px !important',
    height: '18px !important',
    cursor: 'pointer',
  },
  dropdownMenu: {
    marginTop: theme.spacing(1),
    maxHeight: 200,
    minWidth: 390,
  },
  listItemText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },
  countryCallingCode: {
    marginLeft: theme.spacing(2),
    color: theme.palette.secondary.main,
  },
}))

export default styles
